import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Button } from 'antd';
import { withRouter } from 'kts-platform-frame/routes';

const css = require('./UI.AppError.scss');

class UIAppErrorState {
    /** 倒计时 */
    // countdown: number = 3;
}

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** APP未到的错误 */
@ModulesAction.uiconnect
@withRouter
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIAppError extends UIBasic<IProps, ModulesState> {

    state = new UIAppErrorState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        this.modulesState.uiIframeModulesState.isLoad = true;
        this.setModulesState();
    }

    render() {
        return (
            <div className={css.container}>
                <div className={css.body} >
                    <img src={require('./IMG.AppError.png')} alt="" />
                    <h1>抱歉，当前您没有访问权限，请联系管理员</h1>
                    <p>点击下方按钮直接返回</p>
                    <Button onClick={this.onReturnHandler} type="primary">返回到我的应用</Button>
                </div>
            </div>
        );
    }

    private onReturnHandler = () => {
        this.props.history.push('/workbench/myApp');
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/UI.AppError.tsx